import { defineComponent as _defineComponent } from 'vue'
import LFToastComponent from './LFToastComponent.vue'
import useToasts from '@/components/Toasts/composables/useToasts'

// COMPOSABLES

export default /*#__PURE__*/_defineComponent({
  __name: 'LFToastsContainerComponent',
  setup(__props) {

const { toasts } = useToasts()

return { __sfc: true,toasts, LFToastComponent }
}

})